import LegalPage from "./LegalPage";

const H = ({ children }) => (
  <h2 className="font-serif text-2xl text-[var(--pa-text)] mt-8 mb-3">{children}</h2>
);
const P = ({ children }) => (
  <p className="text-[var(--pa-text-muted)] leading-relaxed">{children}</p>
);
const L = ({ children }) => (
  <ul className="list-disc pl-6 space-y-2 text-[var(--pa-text-muted)]">{children}</ul>
);

export default function Baa() {
  return (
    <LegalPage
      title="Business Associate Agreement"
      kicker="HIPAA · BAA"
      testId="baa-page"
    >
      <P>
        This Business Associate Agreement ("BAA") is entered into between you
        (the "Covered Entity") and ProsthoAI ("Business Associate") and governs
        the handling of Protected Health Information ("PHI") as defined under
        the Health Insurance Portability and Accountability Act of 1996
        ("HIPAA"), the Health Information Technology for Economic and Clinical
        Health Act ("HITECH"), and all implementing regulations including
        45 C.F.R. Parts 160 and 164.
      </P>

      <H>1. Definitions</H>
      <P>
        Terms used but not otherwise defined in this BAA shall have the same
        meaning as those terms in the HIPAA Rules. "PHI" means Protected Health
        Information limited to the information created, received, maintained,
        or transmitted by Business Associate from or on behalf of Covered
        Entity.
      </P>

      <H>2. Permitted Uses and Disclosures</H>
      <L>
        <li>
          Business Associate may use and disclose PHI only as necessary to
          perform the services set forth in the underlying Service Agreement
          (the ProsthoAI clinical decision-support platform).
        </li>
        <li>
          Business Associate may use PHI for its proper management and
          administration, and to carry out its legal responsibilities.
        </li>
        <li>
          Business Associate will not use or disclose PHI in a manner that
          would violate the HIPAA Rules if done by Covered Entity.
        </li>
      </L>

      <H>3. Safeguards</H>
      <P>
        Business Associate shall implement administrative, physical, and
        technical safeguards consistent with 45 C.F.R. §164.312 to ensure the
        confidentiality, integrity, and availability of PHI. These safeguards
        include, at minimum:
      </P>
      <L>
        <li>Encryption of PHI in transit (TLS 1.2+) and at rest (AES-256)</li>
        <li>
          Append-only audit logging of every read, write, export, and access
          event on patient data and clinical artifacts
        </li>
        <li>
          Role-based access controls; clinician records are isolated per
          authenticated user
        </li>
        <li>
          Routine access review and revocation; minimum-necessary access by
          design
        </li>
      </L>

      <H>4. Reporting of Use or Disclosure Not Provided For</H>
      <P>
        Business Associate shall report to Covered Entity, without unreasonable
        delay and in no event later than ten (10) business days after
        discovery, any use or disclosure of PHI not provided for by this BAA,
        including breaches of unsecured PHI as required by 45 C.F.R.
        §164.410.
      </P>

      <H>5. Subcontractors</H>
      <P>
        In accordance with 45 C.F.R. §§164.502(e)(1)(ii) and 164.308(b)(2),
        Business Associate shall ensure that any subcontractor that creates,
        receives, maintains, or transmits PHI on behalf of Business Associate
        agrees in writing to the same restrictions, conditions, and
        requirements that apply to Business Associate.
      </P>

      <H>6. Access, Amendment, and Accounting</H>
      <L>
        <li>
          Business Associate shall make PHI available to Covered Entity as
          necessary to satisfy obligations under 45 C.F.R. §164.524.
        </li>
        <li>
          Business Associate shall make amendments to PHI available pursuant
          to 45 C.F.R. §164.526.
        </li>
        <li>
          Business Associate shall make available the information required to
          provide an accounting of disclosures as required by 45 C.F.R.
          §164.528. ProsthoAI's audit-log system supports this requirement.
        </li>
      </L>

      <H>7. Term and Termination</H>
      <P>
        This BAA shall be effective as of the date you accept it via the
        signup flow and shall remain in effect until terminated by either
        party. Upon termination, Business Associate shall return or destroy
        all PHI received from or created on behalf of Covered Entity, except
        where return or destruction is infeasible as permitted under
        45 C.F.R. §164.504(e)(2)(ii)(J).
      </P>

      <H>8. Limitations on Clinical Use</H>
      <P>
        ProsthoAI provides clinical decision support only. ProsthoAI is not a
        substitute for the independent professional judgment of a licensed
        clinician. The treating clinician retains sole responsibility for all
        diagnostic and treatment decisions. AI-generated content must be
        reviewed by the clinician before being relied upon for patient care.
      </P>

      <H>9. Governing Law</H>
      <P>
        This BAA shall be governed by and construed in accordance with the
        laws of the State of Florida and applicable federal law. Acceptance
        of this BAA is recorded with a timestamp, IP address, and version
        identifier on the user's account record.
      </P>

      <P className="mt-8 text-xs text-[var(--pa-text-dim)]">
        Patent Pending · US Application 64/062,147. Designed by Dr. Ronik
        Seecharan DMD, Prosthodontist, Boca Raton, Florida.
      </P>
    </LegalPage>
  );
}
